// src/layouts/MainLayout.js
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
  padding-top: 80px; // Header height for fixed positioning
`;

// Language context for easy access throughout the app
export const LanguageContext = React.createContext({
  language: "tr",
  setLanguage: () => {},
});

const MainLayout = () => {
  const [language, setLanguage] = useState(i18n.language || "tr");

  // Ensure language state stays in sync with i18n
  useEffect(() => {
    setLanguage(i18n.language);
  }, [i18n.language]);

  // When language state changes, update i18n
  useEffect(() => {
    if (language !== i18n.language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      <LayoutWrapper>
        <Header />
        <MainContent>
          <Outlet />
        </MainContent>
        <Footer />
      </LayoutWrapper>
    </LanguageContext.Provider>
  );
};

export default MainLayout;